import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const SeoSection = (): ReactElement => {
  const { t: tSeo } = useTranslation('', { keyPrefix: '$local.$seoSection' });

  return (
    <section className="base-section seo-section hp-section">
      {/* SEO Section */}
      <div className="pattern-2-col">
        <div className="pattern-2-col-background" id="HP_seo">
          <img
            src="/images/homepage/hp-seo.webp"
            alt={tSeo('seoAlt')}
            className="image-2-col hp-seo"
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            width={650}
            height={458}
          />
          <div className="text-2-col">
            <p className="eyebrow">{tSeo('seoEyebrow')}</p>
            <h2>{tSeo('seoTitle')}</h2>
            <p>{tSeo('seoDescription')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeoSection;
